import { render, staticRenderFns } from "./AddGoodsUsage.vue?vue&type=template&id=20b24f14&"
import script from "./AddGoodsUsage.vue?vue&type=script&lang=js&"
export * from "./AddGoodsUsage.vue?vue&type=script&lang=js&"
import style0 from "./AddGoodsUsage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports